export default __webpack_public_path__ + "static/media/CioffWhiteLogo.51abf75f.png";